import { useState } from 'react';
import './DownloadModal.css';

export default function DownloadModal({ onClose, id }) {
    const [mode, setMode] = useState('free');
    const [checked, setChecked] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [telegram, setTelegram] = useState("");

    const checkSubscription = () => {
        setChecked(true);
        setIsSubscribed(true);
    };

    const download = async () => {
        const response = await fetch(`http://api.easy-compress.ru/download/${id}`);

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "";
        a.click();

        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="download-modal">

            <div className="download-modal__card">

                <button
                    className="download-modal__close"
                    onClick={onClose}
                >
                    ×
                </button>

                <h2 className="download-modal__title">
                    Скачать файл
                </h2>

                <div className="download-modal__switch">

                    <button
                        className={mode === 'free' ? 'active' : ''}
                        onClick={() => setMode('free')}
                    >
                        Бесплатно
                    </button>

                    <button
                        className={mode === 'paid' ? 'active' : ''}
                        onClick={() => setMode('paid')}
                    >
                        Платно
                    </button>

                </div>

                {mode === 'free' && (
                    <div className="download-modal__content">

                        <div className="download-modal__icon">
                            ✈
                        </div>

                        <h3>
                            Бесплатное скачивание
                        </h3>

                        <p>
                            Подпишитесь на Telegram-канал и укажите ссылку на свой аккаунт,
                            чтобы мы могли проверить подписку.
                        </p>

                        <a
                            className="download-modal__telegram"
                            href="https://t.me/your_channel"
                            target="_blank"
                        >
                            @your_channel
                        </a>

                        <input
                            className="download-modal__input"
                            placeholder="Введите ссылку на свой Telegram"
                            value={telegram}
                            onChange={(e) => setTelegram(e.target.value)}
                        />

                        <button
                            className="download-modal__button"
                            // onClick={checkSubscription}
                            onClick={download}
                            disabled={!telegram}
                        >
                            Проверить подписку
                        </button>

                        {checked && (
                            <div className="download-modal__success">
                                ✓ Подписка подтверждена
                            </div>
                        )}

                        {isSubscribed && (
                            <button className="download-modal__download">
                                Скачать файл
                            </button>
                        )}

                    </div>
                )}
                {mode === 'paid' && (
                    <div className="download-modal__content">

                        <div className="download-modal__price">
                            30₽
                        </div>

                        <h3>
                            Моментальная загрузка
                        </h3>

                        <p>
                            Без подписки и ожидания.
                        </p>

                        <button className="download-modal__button">
                            Оплатить
                        </button>

                    </div>
                )}

            </div>

        </div>
    );
}
